"use client"

import { useEffect, useState } from "react"

// Avatar <img> that degrades to an initials disc when the URL is missing OR
// fails to load. A dead avatar URL (e.g. the old storage file was deleted by
// a re-upload) previously rendered the browser's broken-image glyph with the
// user's name as alt text in the nav pill.
export function UserAvatarImg({
  src,
  name,
  className = "w-full h-full object-cover",
  fallbackClassName = "w-full h-full flex items-center justify-center text-xs font-semibold",
}: {
  src?: string | null
  name?: string | null
  className?: string
  fallbackClassName?: string
}) {
  const [failed, setFailed] = useState(false)
  // A new URL deserves a fresh attempt (e.g. right after an upload).
  useEffect(() => { setFailed(false) }, [src])

  if (!src || failed) {
    const initial = (name || "").trim().charAt(0).toUpperCase() || "?"
    return <div className={fallbackClassName}>{initial}</div>
  }
  // eslint-disable-next-line @next/next/no-img-element
  return <img src={src} alt={name || "Avatar"} className={`${className} object-[center_25%]`} onError={() => setFailed(true)} />
}
